import React from 'react'
import Layout from '../components/layout'
import SEO from '../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO
      title="Product Development"
      keywords={['gracescale', 'product', 'development']}
    />

    <h2 className="lh-title mt0 mb3 heading f3 f2-l">
      <span className="db-ns">
        We build real-time systems for people who think ahead.
      </span>
    </h2>

    <p>
      The world runs on live information now. Markets, games, the things people care about—they all move in real time, and the edge goes to whoever reads what's happening and acts on it first. Speed is back. So is getting it right.
    </p>

    <p>
      We work with people playing the long game, turning live data into systems that decide, act, and hold up when it matters. Things that actually work, actually last, and actually find the edge.
    </p>

    <div className="flex pt3">
      <a
        href="mailto:hello@gracescale.com"
        target="_blank"
        className="button block sans-serif"
      >
        Talk to us
      </a>
    </div>
  </Layout>
)

export default IndexPage
